module.exports = __webpack_public_path__ + "static/media/firebase.b0c12b32.png";